import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_BATCH_FILE_PDF_REQUEST = 'GET_BATCH_FILE_PDF_REQUEST';
export const GET_BATCH_FILE_PDF_SUCCESS = 'GET_BATCH_FILE_PDF_SUCCESS';
export const GET_BATCH_FILE_PDF_FAILURE = 'GET_BATCH_FILE_PDF_FAILURE';

function request() {
  return {
    type: GET_BATCH_FILE_PDF_REQUEST,
    isFetchingBatchFilePdf: true,
  };
}

function receive(batchFilePdfData, originalFileName) {
  return {
    type: GET_BATCH_FILE_PDF_SUCCESS,
    isFetchingBatchFilePdf: false,
    batchFilePdfData,
    batchFileOriginalFileName: originalFileName,
  };
}

function reject(batchFilePdfError) {
  return {
    type: GET_BATCH_FILE_PDF_FAILURE,
    isFetchingBatchFilePdf: false,
    batchFilePdfError
  };
}

export function getBatchFilePdf(batchFile) {
  return (dispatch) => {
    dispatch(request(batchFile.originalFileName));

    const promise = () => ApiService
      .getBatchFilePdf(batchFile.batchId, batchFile.id, { responseType: 'arraybuffer' })
      .then((response) => {
        dispatch(receive(response.data, batchFile.originalFileName));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response) {
          const status = error.response && error.response.status;
          if (status !== 401) {
            dispatch(
              handleException({ response: { data: { code: status, message: 'Sorry, there was a problem retreiving batch file.  Please try again.' } } }, reject, !status || (status !== 401))
            );
          }
        } else if (error.retries && error.retries > 1) {
          dispatch(handleException(error, reject, false));
        }
      });
    return promise();
  };
}
